import React from 'react';
import { capitalize } from 'utils/strings';
import { CarType, CourierJson } from 'types/bundleTypes';
import { Loader } from 'components/Loader/Loader';
import { ReqEnum } from 'const/requestStatus';

const travelMode = {
  '': 'Transit',
  CAR: 'Car',
  BIKE: 'Bike',
};

function CouriersListNotLoaded() {
  return (
    <tbody>
      <tr>
        <td>
          <Loader type="bounce" size="large" />
        </td>
        <td>
          <Loader type="bounce" size="large" />
        </td>
        <td>
          <Loader type="bounce" size="large" />
        </td>
        <td>
          <Loader type="bounce" size="large" />
        </td>
        <td>
          <Loader type="bounce" size="large" />
        </td>
        <td>
          <Loader type="bounce" size="large" />
        </td>
        <td>
          <Loader type="bounce" size="large" />
        </td>
        <td>
          <Loader type="bounce" size="large" />
        </td>
        <td>
          <Loader type="bounce" size="large" />
        </td>
      </tr>
    </tbody>
  );
}

function formatEtaOffset(seconds: number): string {
  const sign = Math.sign(seconds);
  seconds = Math.abs(seconds);
  const minutes: string | number = Math.floor(seconds / 60);
  const secs: string | number = seconds - minutes * 60;
  const minusPlus = sign < 0 ? '-' : '+';

  if (seconds === 0) {
    return '';
  } else if (minutes === 0) {
    return `${minusPlus}${secs} sec`;
  } else if (secs === 0) {
    return `${minusPlus}${minutes} min`;
  } else {
    return `${minusPlus}${minutes} min ${secs} sec`;
  }
}

export default function CouriersList({
  couriers,
  fetchCouriersStatus,
}: {
  couriers: CourierJson[];
  fetchCouriersStatus: ReqEnum;
}) {
  if (fetchCouriersStatus !== ReqEnum.SUCCESS) {
    return <CouriersListNotLoaded />;
  }
  return (
    <tbody>
      {couriers.map(courier => (
        <tr
          className="courier__list-item"
          key={courier.id}
          style={
            courier.isLocked
              ? {
                  backgroundColor: '#cccccc',
                  color: '#aaa',
                  cursor: 'no-drop',
                }
              : {}
          }
        >
          <td>{courier.id}</td>
          <td>
            {courier.firstName} {courier.lastName}
          </td>
          <td>{courier.companyName}</td>
          <td>
            {courier.phoneCode} {courier.phoneNumber}
          </td>
          <td>{courier.email}</td>
          <td>{courier.rating ? `${courier.rating} / 5` : 'N/A'} </td>
          <td>{capitalize(courier.status)}</td>
          <td>{formatEtaOffset(courier.etaOffsetSeconds)}</td>
          <td>
            {capitalize(CarType[courier.carType]).replaceAll('_', ' ')}{' '}
            {travelMode[courier.travelMode]} {courier.xxl ? 'XL' : ''}
          </td>
        </tr>
      ))}
    </tbody>
  );
}
